/**
 * License feature keys — the exact strings the backend defines in
 * `baserow/core/licensing/features.py`. Backend and frontend share these
 * literals ("Backend and frontend share these exact strings"), so always
 * import from here instead of inlining a string: `$hasFeature` fails closed,
 * meaning a typo would permanently lock a licensed feature's UI without any
 * error. Pinned against the backend vocabulary in
 * `test/unit/core/licenseFeatures.spec.js`.
 */
export const FEATURE_SSO = 'sso'
export const FEATURE_DIRECTORY_SYNC = 'directory_sync'
export const FEATURE_AUDIT_LOG = 'audit_log'
export const FEATURE_COMPLIANCE_CONTROLS = 'compliance_controls'
export const FEATURE_BRANDING = 'branding'
export const FEATURE_DATA_SYNC = 'data_sync'
export const FEATURE_METRICS = 'metrics'
export const FEATURE_UNATTENDED_EXECUTION = 'unattended_execution'
export const FEATURE_ROW_LOCKING = 'row_locking'
export const FEATURE_IMPERSONATION = 'impersonation'
export const FEATURE_EXTERNAL_SECRET_MANAGER = 'external_secret_manager'
export const FEATURE_COLLABORA = 'collabora'
export const FEATURE_ANTIVIRUS = 'antivirus'
export const FEATURE_AI_GENERATION = 'ai_generation'
export const FEATURE_AI_USAGE_LOG = 'ai_usage_log'
export const FEATURE_INSTANCE_MESSAGE = 'instance_message'
export const FEATURE_AUTOMATIC_SNAPSHOTS = 'automatic_snapshots'
export const FEATURE_SEND_FROM_OWN_MAILBOX = 'send_from_own_mailbox'
export const FEATURE_DATA_DISCOVERY = 'data_discovery'
export const FEATURE_APPS = 'apps'
export const FEATURE_ADMIN_ROLES = 'admin_roles'
